<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.SelectFileType')"
    width="400px"
    :close-on-click-modal="false"
    class="app-main-inner settlement-select-dialog"
    :append-to-body="appendToBody"
  >
    <div class="app-main-inner-row" style="padding: 8px 16px 0 16px;">
      <el-input v-model="keyword" no="keyword" :placeholder="$t('Message.EnterKeyword')" style="padding-left: 2px;" @input="onKeywordInput" />
    </div>
    <div class="app-main-inner-row" style="padding: 8px 16px 0 16px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="docTypeTree.gridOptions"
        :row-data="filterRowData"
        style="width:350px;height:300px;padding-left:2px"
        @gridReady="params=>docTypeTree.gridApi=params.api"
      />
    </div>
    <span slot="footer" style="padding-right:30px">
      <el-button no="clear" type="primary" style="float: left;margin-left: 46px;" @click="clearAll">{{ $t('Message.ClearSelectedItems') }}</el-button>
      <el-button no="ok" type="primary" @click="saveDocType()">{{ $t('common.btn.ok') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'MxFileTypeEditor',
  props: {
    visible: { type: Boolean, required: true },
    fileId: { type: String, required: true },
    dataList: { type: Array, required: true },
    fileCategory: { type: String, required: true },
    appendToBody: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: false,
      keyword: '',
      docTypeTree: {
        gridOptions: {
          // 自行实现多选
          // rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.DocumentType'),
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  const iconName = params.data.checked
                    ? 'checkbox-checked'
                    : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                const checked = !params.data.checked
                // 重置所有选中
                // if (checked) {
                //   this.docTypeTree.rowData.forEach(item => {
                //     item.checked = false
                //   })
                // }
                params.data.checked = checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      docTypeMap: new Map(),
      filterRowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true
      await this.buildDocTypeTree()
      this.showDocTypeTree()
      this.onKeywordInput()
    }
  },
  methods: {
    async buildDocTypeTree() {
      if (this.dataList) {
        const data = this.dataList.filter(p => {
          const pathArr = p.path.split(',')
          if (p.type === 1) {
            return pathArr.length === 1
          }
          if (p.type === 2) {
            return pathArr.length > 1
          }
          return false
        })
        data.forEach(item => {
          item.checked = false
          if (item.type === 2) {
            this.docTypeMap.set(item.code.toUpperCase(), item.chineseName)
          }
        })
        this.docTypeTree.rowData = data
      } else {
        this.docTypeTree.rowData = []
      }
    },
    showDocTypeTree() {
      const fileCategory = this.fileCategory.toUpperCase()
      const fileCategories = fileCategory ? fileCategory.split(',') : []
      this.docTypeTree.rowData.forEach(item => {
        if (fileCategories.length > 0 && fileCategories.includes(item.code.toUpperCase())) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
    },

    saveDocType() {
      let fileCategory = ''
      let fileCategoryLabel = ''
      let docTypeRows = this.docTypeTree.rowData.filter(
        p => p.type === 2 && p.checked
      )
      // CARGO-19110文件历史页面，选择文件类型，自动取消 其他 类型
      const screeningRes = docTypeRows.filter(eve => eve.code !== 'other' && eve.code !== 'OTHER')
      if (screeningRes.length > 0) {
        docTypeRows = screeningRes
      }
      let keys = []
      if (docTypeRows.length > 0) {
        let codes = ''
        let labels = ''
        for (const item of docTypeRows) {
          if (codes) {
            codes += ','
          }
          codes += item.code
          if (labels) {
            labels += ','
          }
          labels += item.chineseName
          keys.push(item.code)
        }
        fileCategory = codes
        fileCategoryLabel = labels
      } else {
        fileCategory = ''
        fileCategoryLabel = ''
        keys = []
      }
      const data = { fileCategory, fileCategoryLabel, fileId: this.fileId, documentTypeUuid: keys.join(','), docTypeRows }
      this.$emit('saveFileType', data)
      this.innerVisible = false
    },
    onKeywordInput() {
      if (this.keyword) {
        const matchPathes = []
        for (const row of this.docTypeTree.rowData) {
          if (row.chineseName.indexOf(this.keyword) > -1) {
            matchPathes.push(row.path)
          }
        }
        this.filterRowData = []
        for (const row of this.docTypeTree.rowData) {
          for (const matchPath of matchPathes) {
            if (matchPath.startsWith(row.path) || row.path.startsWith(matchPath)) {
              this.filterRowData.push(row)
              break
            }
          }
        }
        this.$nextTick(() => {
          this.docTypeTree.gridApi.expandAll()
        })
      } else {
        this.filterRowData = this.docTypeTree.rowData
      }
    },
    clearAll() {
      for (const row of this.docTypeTree.rowData) {
        row.checked = false
      }
      this.docTypeTree.gridApi.refreshCells({ force: true })
    }
  }
}
</script>

<style lang="scss">
  .settlement-select-dialog {
    .ag-header {
      display: none;
    }
  }
</style>
